<template>
  <div class="detail">
    <svg-icon class="detail__bg" icon-class="bg"/>
    <div class="detail__entries-today">
      <svg-icon class="entries-today-bg" icon-class="entries-today-bg"/>
      <span class="entries-today-number">{{ data.entries_today }}</span>
      <div class="detail__entries-today__entries-sum" :class="`entries-sum-len-${entriesSumLen}`">
        <svg-icon class="entries-sum" :icon-class="`entries-sum-${entriesSumLen}`"/>
        <span class="title">Entries Sum</span><span class="value">{{ data.entries_sum }}</span>
      </div>
    </div>
    <div class="detail__time-line-today">
      <svg-icon class="cat-icon" icon-class="cat1"/>
      <svg-icon class="bg-icon" icon-class="timelinetoday-bg"/>
      <div class="detail__time-line-today__list">
        <div class="detail__time-line-today__list__item"
             v-for="(item,index) in data.time_line_today"
             :key="index"
        >
          <svg-icon
            :class="index===0?'first-time-line-icon':'time-line-icon'"
            :icon-class="index===0?'first-time-line-icon':'time-line-icon'"/>
          <div class="detail__time-line-today__list__item__time">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="detail__drop-plan">
      <svg-icon class="bg-icon" icon-class="dropplan-bg"/>
      <div class="detail__drop-plan__form">
        <div class="detail__drop-plan__form__item">
          <div class="detail__drop-plan__form__item__label">WorkTime</div>
          <div class="detail__drop-plan__form__item__value">{{ data.start_work_time }}-{{ data.end_work_time }}</div>
        </div>
        <div class="detail__drop-plan__form__item">
          <div class="detail__drop-plan__form__item__label">Time</div>
          <div class="detail__drop-plan__form__item__value">{{ data.system_time }}</div>
        </div>
        <div class="detail__drop-plan__form__item">
          <div class="detail__drop-plan__form__item__label">Serving</div>
          <div class="detail__drop-plan__form__item__value">{{ data.drop_plan_amount }}</div>
        </div>
        <div class="detail__drop-plan__form__item">
          <div class="detail__drop-plan__form__item__label">DropToday</div>
          <div class="detail__drop-plan__form__item__value">{{ data.drop_plan_drop_today }}</div>
        </div>
      </div>
    </div>
    <div class="detail__feeding-advice">
      <svg-icon class="bg-icon" icon-class="feedingadvice-bg"/>
      <div class="detail__feeding-advice__list">
        <div class="detail__feeding-advice__list__item"
             v-for="(item,index) in advice"
             :key="index"
        >
          <div class="detail__feeding-advice__list__item__num">
            <svg-icon icon-class="advice-icon"/>
            <span class="detail__feeding-advice__list__item__num__text">{{ index + 1 }}</span>
          </div>
          <div class="detail__feeding-advice__list__item__text">{{ item }}</div>
        </div>
      </div>
    </div>
    <svg-icon @click="logout" v-if="inOrOut" class="foot-cat-icon" icon-class="in-cat"/>
    <svg-icon @click="logout" v-else class="foot-cat-icon" icon-class="out-cat"/>
  </div>
</template>
<script>

import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { addDoc, collection, getFirestore } from 'firebase/firestore';
import { Base64 } from 'js-base64';

const PRODUCT_ID_LEN = 20;
const ENTRIES_TODAY_LEN = 7;
const HOURS_MINUTES_LEN = 11;
const DROP_TODAY_LEN = 6;
const ENTRIES_SUM_LEN = 18;
const HOURS_LEN = 5;
const DROP_PLAN_DROP_TODAY_LEN = 6;
const DROP_PLAN_AMOUNT_LEN = 4;

function uint8ArrayToBinaryString(uint8Array) {
  let binaryString = '';
  for (let i = 0; i < uint8Array.length; i++) {
    let byte = uint8Array[i];
    let binaryByte = byte.toString(2)
      .padStart(8, '0');
    binaryString += binaryByte;
  }
  return binaryString;
}

function numberToHoursMinutes(number) {
  const hours = parseInt(number / 60)
    .toString()
    .padStart(2, '0');
  const minutes = (number % 60).toString()
    .padStart(2, '0');
  return hours + ':' + minutes;
}

function numberToHours(number) {
  const hours = number.toString()
    .padStart(2, '0');
  return hours + ':00';
}

function binaryStringToNumber(string, start, end) {
  const str = string.substring(start, end);
  return parseInt(str, 2);
}

export default {
  name: 'Detail',
  data() {
    return {
      db: getFirestore(),
      user: null,
      inOrOut: false,
      data: [],
      advice: ['It is recommended to change the location of the machine;', 'It is recommended to change the location of the machine;']
    };
  },
  computed: {
    entriesSumLen() {
      let len = 2;
      console.log(this.data);
      console.log(typeof this.data.entries_sum);
      if (this.data && typeof this.data.entries_sum === 'number') {
        len = this.data.entries_sum.toString().length;
      }
      if (len < 2) {
        len = 2;
      }
      if (len > 6) {
        len = 6;
      }
      return len;
    }
  },
  methods: {
    parsingData(data) {
      const binaryString = uint8ArrayToBinaryString(Base64.toUint8Array(data));
      let index = 0;

      const product_id = binaryStringToNumber(binaryString, index, index = index + PRODUCT_ID_LEN);
      const entries_today = binaryStringToNumber(binaryString, index, index = index + ENTRIES_TODAY_LEN);

      let time_line_today = [];
      for (let i = 0; i < Math.min(entries_today, 20); i++) {
        time_line_today.push(numberToHoursMinutes(binaryStringToNumber(binaryString, index, index = index + HOURS_MINUTES_LEN)));
      }
      time_line_today = time_line_today.reverse();

      const drop_today = binaryStringToNumber(binaryString, index, index = index + DROP_TODAY_LEN);
      const entries_sum = binaryStringToNumber(binaryString, index, index = index + ENTRIES_SUM_LEN);
      const system_time = numberToHoursMinutes(binaryStringToNumber(binaryString, index, index = index + HOURS_MINUTES_LEN));
      const start_work_time = numberToHours(binaryStringToNumber(binaryString, index, index = index + HOURS_LEN));
      const end_work_time = numberToHours(binaryStringToNumber(binaryString, index, index = index + HOURS_LEN));
      const drop_plan_drop_today = binaryStringToNumber(binaryString, index, index = index + DROP_PLAN_DROP_TODAY_LEN);
      const drop_plan_amount = binaryStringToNumber(binaryString, index, index = index + DROP_PLAN_AMOUNT_LEN);

      this.data = {
        product_id,
        entries_today: entries_today.toString()
          .padStart(2, '0'),
        time_line_today,
        drop_today,
        entries_sum,
        system_time,
        start_work_time,
        end_work_time,
        drop_plan_drop_today,
        drop_plan_amount,
        raw_data: data,
        binary_string: binaryString,
      };
    },
    async uploadData(user) {
      try {
        const {
          accessToken,
          displayName,
          email,
          phoneNumber,
          uid,
          providerData,
        } = user;
        const docRef = await addDoc(collection(this.db, 'upload-records'), {
          upload_time: new Date().getTime(),
          user: {
            accessToken,
            displayName,
            email,
            phoneNumber,
            uid,
            providerData
          },
          ...this.data
        });
        console.log('Document written with ID: ', docRef.id);
      } catch (e) {
        console.error('Error adding document: ', e);
      }
    },
    logout() {
      // deleteUser(this.user);
      // alert('logout!');
    }
  },
  created() {
    this.inOrOut = new Date().getTime() % 2 === 1;
    const auth = getAuth();
    console.log(auth);
    const data = sessionStorage.getItem('upload-data') || 'error';
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        this.$router.push(`/${data}`);
      }
    });
    if (!auth.currentUser) {
      this.$router.push(`/${data}`);
      return;
    } else {
      this.user = auth.currentUser;
    }
    if (data && data !== 'error') {
      this.parsingData(data);
      this.uploadData(auth.currentUser);
    }
  },
};
</script>
<style lang="less" scoped>
.detail {
  font-family: 'PawSwingPixelFont';
  background: #000;
  min-height: 100vh;
  overflow-x: hidden;

  &__bg {
    position: absolute;
    left: 408px;
    width: 372px;
    height: 540px;
    top: 2037px;
    z-index: 0;
  }

  .foot-cat-icon {
    width: 780px;
    height: 200px;
    margin-top: 124px;
  }

  &__feeding-advice {
    margin-top: 118px;
    //height: 686px;
    position: relative;
    height: 260px;

    * {
      display: none;
    }

    &__list {
      position: absolute;
      top: 306px;
      left: 96px;
      width: 588px;

      &__item {
        display: flex;
        margin-bottom: 56px;

        &__text {
          line-height: 36px;
        }

        &__num {
          position: relative;
          margin-right: 36px;

          .svg-icon {
            width: 100px;
            height: 86px;
          }

          &__text {
            position: absolute;
            left: 40px;
            top: 30px;
            color: #FFF;
            font-size: 36px;
          }
        }
      }
    }

    .bg-icon {
      position: absolute;
      bottom: 0;
      left: 48px;
      height: 686px;
      width: 704px;
    }
  }

  &__drop-plan {
    height: 618px;
    position: relative;
    margin-top: -20px;
    background: #000;

    &__form {
      width: 588px;
      position: absolute;
      left: 144px;
      top: 230px;

      &__item {
        line-height: 28px;
        display: flex;
        height: 64px;
        align-items: flex-end;
        justify-content: space-between;
        border-bottom: #000 2px solid;
      }
    }

    .bg-icon {
      position: absolute;
      bottom: 0;
      left: 96px;
      height: 618px;
      width: 704px;
    }
  }

  &__time-line-today {
    margin-top: 102px;
    height: 512px;
    position: relative;
    z-index: 1;

    &__list {
      position: absolute;
      bottom: 100px;
      left: 96px;
      width: 588px;
      height: 100px;
      overflow-x: auto;
      overflow-y: hidden;
      display: flex;

      &__item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .first-time-line-icon {
          width: 152px;
          height: 44px;
        }

        .time-line-icon {
          width: 152px;
          height: 28px;
          margin-top: 10px;
        }

        &__time {
          color: #000;
          font-size: 36px;
        }
      }
    }

    .cat-icon {
      position: absolute;
      left: 596px;
      top: 0;
      width: 120px;
      height: 114px;
    }

    .bg-icon {
      position: absolute;
      bottom: 0;
      left: 48px;
      height: 512px;
      width: 704px;
    }
  }

  &__entries-today {
    height: 847px;
    position: relative;

    .entries-today-number {
      position: absolute;
      left: 370px;
      top: 477px;
      font-size: 162px;
      color: #FFF;
    }

    .entries-today-bg {
      width: 732px;
      height: 780px;
      position: absolute;
      left: 48px;
      top: 67px;
    }

    &__entries-sum {
      bottom: -180px;
      position: absolute;
      width: 400px;
      height: 320px;
      color: #FFF;

      .title {
        font-size: 36px;
        position: absolute;
        width: 134px;
        word-break: break-word;
        top: 110px;
      }

      .value {
        font-size: 72px;
        position: absolute;
        top: 150px;
      }
    }

    .entries-sum-len-2 {
      .entries-sum {
        width: 400px;
        height: 320px;
      }

      .title {
        left: 106px;
      }

      .value {
        left: 190px;
      }
    }

    .entries-sum-len-3 {
      .entries-sum {
        width: 440px;
        height: 320px;
      }

      .title {
        left: 88px;
      }

      .value {
        left: 172px;
      }
    }

    .entries-sum-len-4 {
      .entries-sum {
        width: 530px;
        height: 320px;
      }

      .title {
        left: 116px;
      }

      .value {
        left: 200px;
      }
    }

    .entries-sum-len-5 {
      .entries-sum {
        width: 600px;
        height: 320px;
      }

      .title {
        left: 126px;
      }

      .value {
        left: 210px;
      }
    }

    .entries-sum-len-6 {
      .entries-sum {
        width: 600px;
        height: 320px;
      }

      .title {
        left: 96px;
      }

      .value {
        left: 180px;
      }
    }
  }
}
</style>
